import { MMW_URL } from "assets/constant";
import { Layout } from "components/Layout";
import React, { useEffect, useState } from "react";
import styles from "./style.module.css";
import { useRecoilState, useRecoilValue } from "recoil";
import { headerAndBottomVisibleState, headerState } from "recoil/atoms";
import { Header } from "components/Header";
import { Nav } from "components/Nav";
import { gray4, gray6, mainColor } from "assets/styleUtils";
import { SvgLogo } from "assets";
import { modalState } from "recoil/modal";
import { getParameterObject, isAndroid, isIos } from "utils/common";
import { useLocation, useNavigate } from "react-router-dom";
import useUser from "hooks/useUser";
import useModal from "hooks/useModal";
import { getToken } from "utils/ApiUtil";
import { ButtonModal } from "modal";

interface Props {
  children: JSX.Element;
}

interface IChatbotIconProps {
  bottom: string;
  onClick: () => void;
}

interface ISorting {
  text: string;
  value: string;
  url: string;
}

export default function Wrapper({ children }: Props) {
  const header = useRecoilValue(headerState);
  const modal = useRecoilValue(modalState);
  const [headerAndBottomVisible, setHeaderAndBottomVisible] = useRecoilState(
    headerAndBottomVisibleState
  );
  const { isHeader, isBottom } = headerAndBottomVisible;
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { user } = useUser();
  const { visibleModal, removeModal } = useModal();
  const [showAlert, setShowAlert] = useState(false);

  const token = getToken();
  const sortingList: ISorting[] = [
    {
      text: "랜선 결혼식 ",
      value: "online_wedding",
      url: `http://makemywedding-web.s3-website.ap-northeast-2.amazonaws.com?token=${token}`,
    },
    {
      text: "랜선 집들이",
      value: "online_housing",
      url: `http://makemywedding-web.s3-website.ap-northeast-2.amazonaws.com/housewarming?token=${token}`,
    },
  ];

  function existPhone(_sorting: ISorting) {
    if (token) {
      if (user?.phone_number == "" || !user?.phone_number) {
        setShowAlert(true);
      } else {
        window.open(_sorting.url);
      }
    } else {
      removeModal("PLUS_MODAL");
      navigate("/SignIn");
    }
  }
  function openSorting() {
    visibleModal({
      id: "PLUS_MODAL",
      edge: "bottom",
      modalchildren: (
        <div>
          {sortingList.map((_sorting, index) => {
            return (
              <div>
                <a
                  onClick={() => existPhone(_sorting)}
                  key={index}
                  target="_blank"
                  className={styles.plusmodal}
                >
                  <div style={{ display: "flex" }}>
                    <img src="/images/biblemain.png" />
                    <div style={{ fontWeight: "500", marginLeft: "30px" }}>
                      {_sorting.text}
                    </div>
                  </div>
                  <div className={styles.plusmodal_text}>선정시 +5000p</div>
                </a>
                <div
                  style={{
                    width: "100%",
                    height: "2px",
                    backgroundColor: gray6,
                  }}
                />
              </div>
            );
          })}
        </div>
      ),
    });
  }

  function ChatbotIcon(props: IChatbotIconProps) {
    return (
      <img
        src="/images/chatbotIcon.png"
        style={{
          width: "45px",
          height: "45px",
          position: "fixed",
          bottom: props.bottom,
          right: "10px",
        }}
        className="android-chatbot-button"
        onClick={props.onClick}
      />
    );
  }

  useEffect(() => {
    const {
      header: paramsHeader = "true",
      bottom: paramsBottom = "true",
      OS = "",
    } = getParameterObject({
      url: location.search,
    });

    if (paramsHeader === "false" || paramsBottom === "false") {
      setHeaderAndBottomVisible({
        ...headerAndBottomVisible,
        ...(paramsHeader === "false" && { isHeader: false }),
        ...(paramsBottom === "false" && { isBottom: false }),
        ...(["android", "ios"].includes(OS.toLowerCase()) && {
          OS: OS.toLowerCase(),
        }),
      });
    }
  }, [location.search]);

  return (
    <div className={styles.wrap}>
      {/* 점검중일때 전체 화면 블락 */}
      {/* <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(0,0,0,0.4)",
          zIndex: "200",
        }}
        onClick={(e) => {
          e.stopPropagation();
          setShowAlert(false);
        }}
      ></div>
      <ButtonModal
        title={"서비스 점검"}
        sub={"1/11(목) 00:00 ~ 00:20 서비스 점검중입니다."}
        oneButton={{
          color: gray4,
          text: "잠시 후 이용해주세요",
          onClick: () => setShowAlert(false),
        }}
      /> */}
      <div className={styles.left}></div>
      <div className={styles.center}>
        {!pathname.includes("/SignIn/InquiryBoxList") &&
          !pathname.includes("/SignIn/MyPointList") && (
            <Header {...header} isVisible={isHeader} left="back" />
          )}
        {showAlert && (
          <>
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100vh",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(0,0,0,0.4)",
                zIndex: "200",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setShowAlert(false);
              }}
            ></div>
            <ButtonModal
              title={"핸드폰 인증"}
              sub={"핸드폰 번호를 인증해주세요."}
              oneButton={{
                color: gray4,
                text: "아니요",
                onClick: () => setShowAlert(false),
              }}
              twoRightButton={{
                color: mainColor,
                text: "인증하러 가기",
                onClick: () => {
                  setShowAlert(false);
                  removeModal("PLUS_MODAL");
                  navigate("/SignIn/MyProfilePage");
                },
              }}
            />
          </>
        )}
        <div
          id="wrapper"
          className={styles.centerCont}
          style={modal.length > 0 ? { overflowY: "hidden" } : {}}
        >
          {children}
        </div>
        <Nav isVisible={isBottom} />
      </div>

      {(isAndroid() || isIos()) && (
        <ChatbotIcon
          bottom="70px"
          onClick={() => window.ChannelIO?.("showMessenger")}
        />
      )}
      {isAndroid() || isIos() ? (
        <div className={styles.plusbutton_mobile} onClick={() => openSorting()}>
          <img
            src="/images/plus.png"
            style={{
              width: "20px",
              height: "20px",
            }}
          />
        </div>
      ) : (
        <div className={styles.plusbutton} onClick={() => openSorting()}>
          <img
            src="/images/plus.png"
            style={{
              width: "20px",
              height: "20px",
            }}
          />
        </div>
      )}
      <div className={styles.right}>
        <div className={styles.rightCont}>
          <Layout>
            <div className={styles.title}>
              <SvgLogo style={{ fill: mainColor }} />
              <h2>
                나만의 웨딩 만들기
                <br />
                필수 웨딩 플랫폼
              </h2>
              <h1>메이크마이웨딩</h1>
            </div>

            <div className={styles.visual}>
              <p>
                메이크마이웨딩을 통해
                <br />
                <b>나만의 결혼 & 신혼라이프</b>를<br />
                만들어보세요
              </p>
              <img src="/images/banner_visual.png" alt="phone" />
            </div>

            <ul className={styles.store}>
              <li>
                <p>플레이 스토어에서 다운로드</p>
                <img className={styles.qr} src="/images/qr.png" alt="qr" />
              </li>
              <li>
                <p>앱스토어에서 다운로드 </p>
                <div className={styles.storeButton}>
                  <a href={MMW_URL.ios} target="_blank">
                    <img src="/images/appStore.png" alt="appStore" />
                  </a>
                  <a href={MMW_URL.android} target="_blank">
                    <img src="/images/googlePlay.png" alt="googlePlay" />
                  </a>
                </div>
              </li>
            </ul>
          </Layout>

          <div className={styles.sns}>
            <a href={MMW_URL.cafe} target="_blank">
              <img src="/images/sns_naver.png" alt="naver" />
              <p>네이버 카페</p>
            </a>
            <a href={MMW_URL.instagram} target="_blank">
              <img src="/images/sns_instagram.png" alt="instagram" />
              <p>인스타그램</p>
            </a>
            <a href={MMW_URL.blog} target="_blank">
              <img src="/images/sns_blog.png" alt="blog" />
              <p>네이버 블로그</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
